import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useTemplateDraft() {
  const mutationFactory = useCallback(() => {
    const query = `mutation getOrCreateDraftTemplate($processId: ID!) {
      getOrCreateDraftTemplate(processId: $processId) {
        release {
          id
          title
          about
          documentationLink
          documentationTitle
        }
      }
    }`;

    const resolver = ({ data: { getOrCreateDraftTemplate } }) => {
      return {
        data: getOrCreateDraftTemplate.release,
      };
    };

    return { query, resolver };
  }, []);

  const [getOrCreateDraft, { loading }] =
    useMutationWithToaster(mutationFactory);

  return {
    getOrCreateDraft: (processId) => {
      return getOrCreateDraft(
        {
          processId: toGlobalId("Process", processId),
        },
        {
          successMsg: "Successfully created template.",
          defaultErrorMsg: "Failed to create template.",
        }
      );
    },
    loading: loading,
  };
}

export default useTemplateDraft;
